<template>
  <v-card style="border-radius: 12px;" :max-width="$vuetify.breakpoint.smAndUp ? '450px' : 'auto'" elevation="10">
    <v-card-title class="heading">
      <v-row align="center" class="ma-0">
        <span style="color: #47464A; font-weight: 600;">Marker</span>
        <v-spacer></v-spacer>
        <v-btn icon depressed @click="onEditClick" :disabled="isDeleting">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.33325 16.6666H6.66658L15.4166 7.91663C15.8586 7.47461 16.1069 6.87509 16.1069 6.24997C16.1069 5.62485 15.8586 5.02533 15.4166 4.5833C14.9746 4.14127 14.375 3.89294 13.7499 3.89294C13.1248 3.89294 12.5253 4.14127 12.0833 4.5833L3.33325 13.3333V16.6666Z"
              stroke="#47464A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.25 5.41669L14.5833 8.75002" stroke="#47464A" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </v-btn>
        <v-btn icon depressed @click="onDeleteClick" :loading="isDeleting">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.33325 5.83331H16.6666" stroke="#F75151" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M8.33325 9.16669V14.1667" stroke="#F75151" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M11.6667 9.16669V14.1667" stroke="#F75151" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M4.16675 5.83331L5.00008 15.8333C5.00008 16.2753 5.17568 16.6993 5.48824 17.0118C5.8008 17.3244 6.22472 17.5 6.66675 17.5H13.3334C13.7754 17.5 14.1994 17.3244 14.5119 17.0118C14.8245 16.6993 15.0001 16.2753 15.0001 15.8333L15.8334 5.83331"
              stroke="#F75151" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333"
              stroke="#F75151" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </v-btn>
        <v-btn icon depressed @click="onCloseClick" color="#47464A" :disabled="isDeleting">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text>
      <div style="margin-top: 15px;">
        <div style="font-size: 18px; margin-bottom: 20px;">
          <div>Latitude:</div>
          <div style="margin-top: 10px; color: #47464A;">{{ Layer.getLatLng().lat | toFixed }}</div>
        </div>
        <v-divider></v-divider>
      </div>
      <div style="margin-top: 15px;">
        <div style="font-size: 18px; margin-bottom: 20px;">
          <div>Longitude:</div>
          <div style="margin-top: 10px; color: #47464A;"> {{ Layer.getLatLng().lng | toFixed }}</div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { FEATURE_CARD_STATE } from "../../../../helpers/geometries/constants"
import { FloatingCardsEventBus } from "../../../../helpers/mapview/events"
import { DIALOG_TYPES, DialogOptions } from "../../../../helpers/dialogs"
import { FEATURE_GROUPS } from "../../../../helpers/leaflet/constants"

const _MarkerMap = Symbol.for("_MarkerMap")
const _MarkerLayer = Symbol.for("_MarkerLayer")
const _MarkerFeature = Symbol.for("_MarkerFeature")

export default {
  name: "MarkerViewCard",
  inject: { _MarkerFeature, _MarkerLayer, _MarkerMap },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isDeleting: false,
  }),
  methods: {
    onCloseClick() {
      FloatingCardsEventBus.$emit("close")
    },
    onDeleteClick() {
      this.$dialog(new DialogOptions({
        title: "Delete Marker",
        content: "Are you sure you want to delete this marker?",
        type: DIALOG_TYPES.CONFIRM,
        onConfirm: this.deleteHandler
      }))
    },
    deleteHandler() {
      const f = () => {
        this.Map.featureGroups[FEATURE_GROUPS.FEATURES].removeLayer(this.Layer)
        FloatingCardsEventBus.$emit("close")
      }

      this.isDeleting = true
      this.Feature.delete(this.Feature["id_processing_geometry"], f)
        .finally(() => {
          this.isDeleting = false
        })
    },
    onEditClick() {
      this.$emit("update:mode", FEATURE_CARD_STATE.EDIT)
    },
  },
  filters: {
    toFixed(value) {
      return value.toFixed(6)
    }
  },
  computed: {
    Map() {
      return this._MarkerMap()
    },
    Feature() {
      return this._MarkerFeature()
    },
    Layer() {
      return this._MarkerLayer()
    },
  },
}
</script>

<style scoped></style>
